import { CellProps, Badge } from "@shared/primitive-components"
import { AddedFleetEntry } from "../../../../../../api/fleet"

export const StatusCell = ({ row }: CellProps<string, AddedFleetEntry>) => {
  const isNotResolved = !row.original.vehicleId
  if (isNotResolved) {
    return <Badge variant="error">error</Badge>
  }
  return <Badge variant="valid">ready</Badge>
}
